import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import ReactionsIcon from 'hb-react/shared/components/DesignSystem/Reactions/components/ReactionsIcon';
import ReactionsWrapper from 'hb-react/shared/components/DesignSystem/Reactions/components/ReactionsWrapper';
import onEnterOrSpacePress from 'hb-react/shared/utils/onEnterOrSpacePress';

const ReactionsComments = ({
  totalComments = 0,
  showFullText = true,
  onClick,
  ariaExpanded = false,
  dataTestId = '',
  height = '20px',
}) => (
  <ReactionsWrapper
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyPress={onEnterOrSpacePress(onClick)}
    aria-label={__('Comment')}
    aria-expanded={ariaExpanded}
    data-testid={dataTestId}
  >
    <ReactionsIcon>
      <FontAwesomeIcon height={height} iconName="message" iconType="light" />
    </ReactionsIcon>
    {showFullText
      ? __('Comment')
      : totalComments > 0 && (
          <Box display="block" mr={2}>
            {totalComments}
          </Box>
        )}
  </ReactionsWrapper>
);

ReactionsComments.propTypes = {
  ariaExpanded: PropTypes.bool,
  dataTestId: PropTypes.string,
  showFullText: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  totalComments: PropTypes.number,
  height: PropTypes.string,
};

export default ReactionsComments;
